import React from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { ScrollArea } from '@/components/ui/scroll-area';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { FileType as GlobalFileType } from '../../../../types';

interface SelectedFilesDropdownProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  cachedFiles: GlobalFileType[];
  onFileSelect: (file: GlobalFileType) => void;
}

const SelectedFilesDropdown: React.FC<SelectedFilesDropdownProps> = ({
  open,
  onOpenChange,
  cachedFiles,
  onFileSelect,
}) => {
  const { t } = useTranslation();

  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <span />
      </PopoverTrigger>
      <PopoverContent
        side="top"
        align="start"
        sideOffset={8}
        alignOffset={20}
        collisionPadding={16}
        className="p-0 w-80 border-0 shadow-none"
      >
        <div className="w-80 max-h-80 overflow-hidden bg-popover border border-border rounded-md shadow-md">
          <div className="flex items-center gap-3 px-6 py-3 border-b border-gray-200 dark:border-gray-700">
            <h3 className="text-sm font-medium">
              {t('drawer.multiAskAI.selectedFiles', 'Selected Files')}
            </h3>
          </div>
          <ScrollArea className="max-h-64">
            <div>
              {cachedFiles.map((file) => (
                <button
                  key={file._id}
                  type="button"
                  onClick={() => onFileSelect(file)}
                  className="w-full text-left group flex items-center gap-3 px-6 py-2.5 mb-0.5 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors relative"
                >
                  <div className="flex-1 min-w-0">
                    <div className="text-sm line-clamp-1 font-normal">
                      {file.name}
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      onFileSelect(file);
                    }}
                    className="opacity-0 group-hover:opacity-70 hover:opacity-100 transition-opacity"
                  >
                    <X className="h-4 w-4" />
                  </button>
                </button>
              ))}
            </div>
          </ScrollArea>
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default SelectedFilesDropdown;
